import React from 'react';
import { useQuery } from 'react-query';
import { RouteComponentProps, useHistory, useParams } from 'react-router-dom';
import BackButton from '../../components/AppBackButton/BackButton';
import Loader from '../../components/AppLoader/Loader';
import PriceList from '../../components/PriceLIst/PriceList';
import { getOnlineMockExamCourses } from '../../moduls/online-mock-exam-courses';
import { OnlineMockExamCourseType } from '../../services/types';
import './OnlineMockExamCourses.scss';
import OnlineMockExamCourseForm from '../../components/Forms/OnlineMockExamCourseForm';

const OnlineMockExamCoursesDetail: React.FC<RouteComponentProps> = () => {
    const { id } = useParams<{ id: string }>();
    const { data: courses = [], isFetched } = useQuery<OnlineMockExamCourseType[]>(['online-mock-exam-courses', { id: +id }], getOnlineMockExamCourses);

    if (!isFetched) return <Loader />;

    const course = courses[0] || {};

    if (!course) return null;

    const createMarkup = () => ({ __html: course.description });

    return (
        <>
            <div className="col-lg-4 col-md-10 left-column">
                <div className="left-column-content">
                    <div className="left-column-label">Popis kurzu:</div>
                    <div className="description" dangerouslySetInnerHTML={createMarkup()}></div>
                </div>

                <div className="left-column-content">
                    <div className="left-column-label">Galerie:</div>
                    <div>
                        <img src={course.gallery[0]?.fullPath} alt={course.gallery[0]?.name} />
                        <img src={course.gallery[1]?.fullPath} alt={course.gallery[1]?.name} />
                        <img src={course.gallery[2]?.fullPath} alt={course.gallery[2]?.name} />
                        <img src={course.gallery[3]?.fullPath} alt={course.gallery[3]?.name} />
                    </div>
                </div>

            </div>
            <div className="col-lg-7 col-md-10 right-column">
                <h1 className="h-text-center">
                    On-line {course.name}
                </h1>
                <PriceList
                    singlePrice={course.lesson_price}
                    totalPrice={course.price}
                    prices={course.price_packages || []}
                    nounSingular='test'
                    nounPlural='testy'
                    nounPlural5more='testů'
                />
                <p>Můžete používat až na 3 zařízeních.</p>
                <OnlineMockExamCourseForm course={course} />
                <BackButton />
            </div>
        </>
    );
};

export default OnlineMockExamCoursesDetail;
